<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="header-title">
            <h4 class="m-0 title-modal">Informações do contato</h4>
            <div class="ml-3 chip">
              <p class="m-0 order-type">
                {{
                  boobleModalData?.type == "SenderAccount"
                    ? "Pagador no exterior"
                    : "Beneficiário no exterior"
                }}
              </p>
            </div>
          </div>
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
        <ng-container *ngIf="boobleModalData?.type == 'SenderAccount'">
          <div class="modal-dialog-scrollable-general">
            <div class="mt-5 modal-body">
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.senderReceiverName }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                      ><span class="ml-2">{{
                        this.currency?.description
                      }}</span>
                    </span></span
                  ><br /><br />
                </div>

                <div class="col-md-6">
                  <span class="p-text-grey">
                    E-mail:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.email }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey">
                    País:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.country?.description }}
                    </span></span
                  ><br /><br />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="boobleModalData?.type == 'ReceiverAccount'">
          <div class="modal-dialog-scrollable-general">
            <div class="mt-5 modal-body">
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Nome:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.senderReceiverName }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                      ><span class="ml-2">{{
                        this.currency?.description
                      }}</span>
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Banco: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.name
                    }}</span></span
                  ><br /><br />
                  <ng-container *ngIf="this.boobleModalData?.number">
                    <span class="p-text-grey"
                      >Conta: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.number
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container *ngIf="this.boobleModalData?.institutionNumber">
                    <span class="p-text-grey"
                      >Institution Number: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.institutionNumber
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.transit">
                    <span class="p-text-grey"
                      >Transit: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.transit
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.address">
                    <span class="p-text-grey"
                      >Address: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.address
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container *ngIf="this.boobleModalData?.cbu">
                    <span class="p-text-grey"
                      >CBU: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.cbu
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                  <ng-container *ngIf="this.boobleModalData?.sortCode">
                    <span class="p-text-grey"
                      >Sort Code: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.sortCode
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                </div>

                <div class="col-md-6">
                  <span class="p-text-grey">
                    País:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.country?.description }}
                    </span></span
                  ><br /><br />
                  <span class="p-text-grey"
                    >Código SWIFT: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.swift
                    }}</span></span
                  ><br /><br />
                  <ng-container *ngIf="this.boobleModalData?.aba">
                    <span class="p-text-grey"
                      >ABA: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.aba
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.iban">
                    <span class="p-text-grey"
                      >IBAN: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.iban
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.cable">
                    <span class="p-text-grey"
                      >Cable: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.cable
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.blz">
                    <span class="p-text-grey"
                      >BLZ: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.blz
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.fcc">
                    <span class="p-text-grey"
                      >FFC: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.fcc
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.cuit">
                    <span class="p-text-grey"
                      >CUIT: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.cuit
                      }}</span></span
                    ><br /><br />
                  </ng-container>

                  <ng-container *ngIf="this.boobleModalData?.bsb">
                    <span class="p-text-grey"
                      >BSB: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.bsb
                      }}</span></span
                    ><br /><br />
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="buttons">
          <button
            class="stroked-red"
            (click)="openRemoveContactModal(boobleModalData?.id)"
            mat-stroked-button
          >
            Remover
          </button>

          <button
            type="button"
            class="btn-footer btn btn-dark-primary-blue"
            (click)="
              openAddContactModal({ contact: boobleModalData, isEdit: true })
            "
          >
            Editar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
